const Bylaws = () => {

  return (
    <div>
      <h1>Bylaws</h1>
      <ol>
        <li>For best / worst books of the year, last meeting date must be in calendar year</li>
        <li>Max 14 hours in 2 weeks</li>
        <li>No nonfiction</li>
        <li>Sequels if everyone agrees</li>
      </ol>
      <h2>Amendments</h2>
      <ol>
        <li>Best of meeting is 1st of January</li>
        <li>Worst book votes must be for completed books or DNF for badness with 10% minimum read</li>
      </ol>      
      <img src="/book-club/bylaws.jpeg" alt="Bylaws" />
    </div>
  );
};

export default Bylaws;
